import {Directive, TemplateRef} from "@angular/core";
import {DxPageHeaderBaseDirective} from "./dx-page-header-base.directive";

/**
 * Структурная директива для переопределения шаблона области под раздел настроек в шапке.
 * @publicApi
 */
@Directive({selector: '[dxPageHeaderSettingsBar]'})
export class DxPageHeaderSettingsBarDirective extends DxPageHeaderBaseDirective {
  constructor(public template: TemplateRef<any>) {
    super();
  }
}
